import React, { FC, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { SCREEN_BREAKPOINTS } from "src/constants/screenBreakpoints";
import { ReactComponent as MenuIcon } from "src/assets/icons/menu.svg";
import { Logo } from "../Logo";
import { NavMenu } from "./NavMenu";
import { Button } from "../Button";
import { Menu } from "./Menu";

interface Props {
  isShown: boolean;
}
export const Header: FC<Props> = () => {
  const isXLScreenBreakpoint = useMediaQuery({
    maxWidth: SCREEN_BREAKPOINTS.XL,
  });

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const onClickMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const onCloseMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="flex items-center justify-between max-h-25 h-full px-6">
      <Logo />

      {isXLScreenBreakpoint ? (
        <Button className="z-30" onClick={onClickMenu}>
          <MenuIcon />
        </Button>
      ) : (
        <NavMenu />
      )}

      <Menu isShown={isMenuOpen} onClose={onCloseMenu} />
    </header>
  );
};
